<template>
  <v-container fluid>
    <v-card
      v-if="
        isWordListReady && !displayConfirmDialog && !displayCompletedDialog
      "
      flat
    >
      <Form ref="formRef" v-slot="{ meta }">
        <v-card flat>
          <v-card-title class="mb-3 text-h5 font-weight-bold">
            {{ wordList.lbl_delivery_regist }}
          </v-card-title>
          <v-card-text>
            <v-row dense class="mb-3">
              <!-- 配達元 -->
              <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
                <v-row align="center" dense class="form-label-row mr-15 justify-sm-end">
                  {{ wordList.lbl_delivery_source }}
                </v-row>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="6"
                lg="6"
                class="text-body-1 color_black"
              >
                {{
                  shopData !== null && shopData !== undefined
                    ? shopData.name
                    : ""
                }}
              </v-col>
            </v-row>
            <v-row dense>
              <!-- 配達先住所 -->
              <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
                <v-row align="center" dense class="form-label-row mr-3 justify-sm-end"
                  >{{ wordList.lbl_delivery_destination_address }}
                  <ImportantChip></ImportantChip
                ></v-row>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="6"
                lg="6"
                class="text-body-1 mb-2 color_black"
              >
                {{ deliveryRequestCreateInput.delivery_zip_code ? "〒" : "" }}
                {{
                  deliveryRequestCreateInput.delivery_zip_code.substring(0, 3)
                }}
                {{ deliveryRequestCreateInput.delivery_zip_code ? "-" : "" }}
                {{ deliveryRequestCreateInput.delivery_zip_code.substring(3) }}
                {{ deliveryRequestCreateInput.delivery_address1 }}
              </v-col>
            </v-row>
            <!-- 住所選択ボタン -->
            <v-row class="mt-0">
              <v-col cols="12" sm="4" md="4" lg="4"></v-col>
              <v-col class="pl-2 pt-0"
                ><v-btn
                  size="small"
                  color="primary"
                  variant="outlined"
                  @click="onClickAddressUpdate"
                  >{{ wordList.btn_area_select }}</v-btn
                ></v-col
              >
            </v-row>
            <v-row dense class="mt-5">
              <!-- 配達先住所(番地) -->
              <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
                <v-row align="center" dense class="form-label-row mr-3 justify-sm-end">
                  {{ wordList.lbl_delivery_destination_address_detail }}
                  <ImportantChip></ImportantChip>
                </v-row>
              </v-col>
              <v-col cols="12" sm="6" md="6" lg="6">
                <Field
                  v-slot="{ errors }"
                  v-model="deliveryRequestCreateInput.delivery_address2"
                  :name="wordList.lbl_delivery_destination_address_detail"
                  rules="required|max:100"
                >
                  <v-text-field
                    v-model="deliveryRequestCreateInput.delivery_address2"
                    :placeholder="
                      wordList.plc_delivery_destination_address_detail
                    "
                    density="compact"
                    variant="outlined"
                    :error-messages="errors"
                  ></v-text-field>
                </Field>
              </v-col>
            </v-row>
            <v-row dense>
              <!-- 建物名 部屋番号 -->
              <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
                <v-row align="center" dense class="form-label-row mr-15 justify-sm-end">{{
                  wordList.lbl_room_num
                }}</v-row>
              </v-col>
              <v-col cols="12" sm="6" md="6" lg="6">
                <Field
                  v-slot="{ errors }"
                  v-model="deliveryRequestCreateInput.delivery_address3"
                  :name="wordList.lbl_room_num"
                  rules="max:100"
                >
                  <v-text-field
                    v-model="deliveryRequestCreateInput.delivery_address3"
                    :placeholder="wordList.plc_room_num"
                    density="compact"
                    variant="outlined"
                    :error-messages="errors"
                  ></v-text-field>
                </Field>
              </v-col>
            </v-row>
            <v-row dense>
              <!-- 配達希望エリア -->
              <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
                <v-row align="center" dense class="form-label-row mr-3 justify-sm-end">
                  {{ wordList.lbl_delivery_area }}
                  <ImportantChip></ImportantChip>
                </v-row>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="6"
                lg="6"
                class="text-body-1 color_black"
              >
                <v-row
                  v-if="
                    listDeliveryArea == null || listDeliveryArea.length <= 1
                  "
                  dense
                >
                  <Field
                    v-model="deliveryAreaName"
                    :name="wordList.lbl_delivery_area"
                    rules="required"
                  >
                    <v-text-field
                      v-model="deliveryAreaName"
                      density="compact"
                      variant="plain"
                      readonly
                    >
                    </v-text-field>
                  </Field>
                </v-row>
                <v-row
                  v-if="
                    listDeliveryArea !== null &&
                    listDeliveryArea !== undefined &&
                    listDeliveryArea.length > 1
                  "
                  dense
                >
                  <v-btn
                    v-for="value in listDeliveryArea"
                    :key="value.area_code"
                    class="my-2 mx-2"
                    :class="{
                      btn_select_del_active:
                        value.area_code ===
                        deliveryRequestCreateInput.area_code,
                    }"
                    color="primary"
                    variant="outlined"
                    min-width="200"
                    @click="onClickListDeliveryArea(value)"
                  >
                    {{ value.area_name }}
                  </v-btn>
                </v-row>
              </v-col>
            </v-row>
            <v-row dense>
              <!-- 配達希望時間選択 -->
              <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
                <v-row align="center" dense class="form-label-row mr-3 justify-sm-end">
                  {{ wordList.lbl_delivery_time_select }}
                  <ImportantChip></ImportantChip>
                </v-row>
              </v-col>
              <v-col
                cols="12"
                sm="8"
                md="8"
                lg="8"
                class="text-body-1 color_black"
              >
                <Field
                  v-model="displayDeliveryTime"
                  :name="wordList.lbl_delivery_time_select"
                  rules="required"
                >
                  <v-text-field
                    v-model="displayDeliveryTime"
                    density="compact"
                    variant="plain"
                    readonly
                    hide-details
                  >
                  </v-text-field>
                </Field>
                <v-card
                  v-if="disp_deliveryAvailabilityData.length > 0"
                  class="mt-2 mb-8 px-3 pt-3"
                  border
                  flat
                >
                  <div id="wrap">
                    <div class="d-flex overflow-x-auto">
                      <div>
                        <div class="list_item_select_blank"></div>
                        <ul class="list_area br_b_1">
                          <li
                            v-for="[
                              delivery_id_desc,
                            ] in deliveryAvailabilityHeader"
                            :key="delivery_id_desc"
                            class="list_item_select_time"
                          >
                            {{ delivery_id_desc }}
                          </li>
                        </ul>
                      </div>
                      <div class="d-flex overflow-scrollr br_b_1">
                        <div
                          v-for="(
                            cols, deliverySelectDay
                          ) in disp_deliveryAvailabilityData"
                          :key="cols.delivery_data"
                        >
                          <ul
                            v-for="(delivery_data, deliverySelect) in cols"
                            :key="
                              delivery_data.delivery_date + delivery_data.key
                            "
                            class="list_area list_area_item"
                          >
                            <li
                              v-if="delivery_data.key == 1"
                              class="list_item_select list_item_day"
                            >
                              <div>
                                <p class="mb-0">
                                  {{ formatDate(delivery_data.delivery_date) }}
                                </p>
                              </div>
                            </li>
                            <li class="list_item_select list_item_btn">
                              <a
                                v-if="
                                  delivery_data.already_requested !== 1 &&
                                  delivery_data.availability !== '×' &&
                                  delivery_data.availability !== '0' &&
                                  delivery_data.availability !== '休'
                                "
                                class="btn_select_del"
                                :class="{
                                  btn_select_del_active:
                                    deliverySelectDay ===
                                      Number(deliverySelectDayBox) &&
                                    deliverySelect ===
                                      Number(deliverySelectBox),
                                }"
                                @click="
                                  onDeliveryAvailabilityClick(
                                    delivery_data.delivery_date,
                                    String(delivery_data.delivery_id),
                                    delivery_data.delivery_start_time,
                                    delivery_data.delivery_end_time,
                                    String(deliverySelectDay),
                                    String(deliverySelect)
                                  )
                                "
                              >
                                <!--<i :class="getClass(delivery_data.availability)"></i>-->
                                <i
                                  v-if="delivery_data.availability == '○'"
                                  class="circle_receive"
                                  :class="{
                                    circle_receive_active:
                                      deliverySelectDay ===
                                        Number(deliverySelectDayBox) &&
                                      deliverySelect ===
                                        Number(deliverySelectBox),
                                  }"
                                ></i>
                                <i
                                  v-else-if="
                                    delivery_data.availability == '△' ||
                                    delivery_data.availability == '▲'
                                  "
                                  class="triangle_receive"
                                  :class="{
                                    triangle_receive_active:
                                      deliverySelectDay ===
                                        Number(deliverySelectDayBox) &&
                                      deliverySelect ===
                                        Number(deliverySelectBox),
                                  }"
                                ></i>
                                <div
                                  v-else
                                  class="text_16px font-weight-bold color_primary"
                                >
                                  {{ delivery_data.availability }}
                                </div>
                              </a>
                              <div
                                v-if="delivery_data.already_requested === 1"
                                class="btn_select_del_dis"
                              >
                                <v-icon>mdi-check-bold</v-icon>
                              </div>
                              <div
                                v-else-if="
                                  delivery_data.availability === '×' ||
                                  delivery_data.availability === '0'
                                "
                              >
                                <i class="batsu_receive"></i>
                              </div>
                              <div
                                v-else-if="delivery_data.availability === '休'"
                                class="text_16px font-weight-bold color_primary"
                              >
                                {{ delivery_data.availability }}
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </v-card>
                <p v-if="deliveryId_0_Flg" class="pt-0 mt-0">
                  ※配達開始時間
                  {{ deliveryStartTime }}～(当日配達)受付終了時間
                  {{ acceptableEndTime }}まで
                </p>
              </v-col>
            </v-row>
            <!-- 配達希望時間 -->
            <v-row
              v-if="
                deliveryId_0_Flg &&
                deliveryRequestCreateInput.delivery_id !== undefined &&
                deliveryRequestCreateInput.delivery_id != null &&
                !is_hide_delivery_time_on_spot
              "
              dense
            >
              <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
                <v-row align="center" dense class="form-label-row mr-15 justify-sm-end">
                  {{ wordList.lbl_delivery_time }}
                </v-row>
              </v-col>
              <v-col cols="1" sm="1" md="1" lg="1">
                <v-autocomplete
                  v-model="deliveryStartHourValues"
                  density="compact"
                  :items="deliveryStartHourItem"
                  item-title="deliveryStartHour"
                  item-value="deliveryStartHour"
                  :no-data-text="wordList.lbl_no_data_text"
                  bg-color="white"
                  return-object
                  variant="outlined"
                  @update:model-value="onChangeDeliveryStartHour"
                ></v-autocomplete>
              </v-col>
              <p class="mt-3 mx-2 center text-body-1 text-black">時</p>
              <v-col cols="1" sm="1" md="1" lg="1">
                <v-autocomplete
                  v-model="deliveryStartMinitValues"
                  density="compact"
                  :items="deliveryStartMinitItem"
                  item-title="label"
                  item-value="deliveryStartMinit"
                  :no-data-text="wordList.lbl_no_data_text"
                  bg-color="white"
                  return-object
                  variant="outlined"
                  @update:model-value="onChangeDeliveryStartMinit"
                ></v-autocomplete>
              </v-col>
              <p class="mt-3 mx-2 center text-body-1 text-black">
                分から3時間以内
              </p>
            </v-row>
            <!-- お名前(漢字) -->
            <v-row dense>
              <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
                <v-row align="center" dense class="form-label-row mr-3 justify-sm-end">
                  {{ wordList.lbl_name_kanji }}
                  <ImportantChip></ImportantChip>
                </v-row>
              </v-col>
              <v-col cols="6" sm="3" md="3" lg="3">
                <Field
                  v-slot="{ errors }"
                  v-model="deliveryRequestCreateInput.delivery_name1"
                  name="delivery_name1"
                  :label="wordList.lbl_name_kanji + '（姓）'"
                  rules="required|max:100"
                >
                  <v-text-field
                    v-model="deliveryRequestCreateInput.delivery_name1"
                    :placeholder="wordList.plc_family_name_kanji"
                    density="compact"
                    variant="outlined"
                    :error-messages="errors"
                  ></v-text-field>
                </Field>
              </v-col>
              <v-col cols="6" sm="3" md="3" lg="3">
                <Field
                  v-slot="{ errors }"
                  v-model="deliveryRequestCreateInput.delivery_name2"
                  name="delivery_name2"
                  :label="wordList.lbl_name_kanji + '（名）'"
                  rules="required|max:100"
                >
                  <v-text-field
                    v-model="deliveryRequestCreateInput.delivery_name2"
                    :placeholder="wordList.plc_first_name_kanji"
                    density="compact"
                    variant="outlined"
                    :error-messages="errors"
                  ></v-text-field>
                </Field>
              </v-col>
            </v-row>
            <v-row dense>
              <!-- お名前(かな) -->
              <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
                <v-row align="center" dense class="form-label-row mr-3 justify-sm-end"
                  >{{ wordList.lbl_name_kana }}
                  <ImportantChip></ImportantChip>
                </v-row>
              </v-col>
              <v-col cols="6" sm="3" md="3" lg="3">
                <Field
                  v-slot="{ errors }"
                  v-model="deliveryRequestCreateInput.delivery_name_kana1"
                  name="delivery_name_kana1"
                  :label="wordList.lbl_name_kana + '（姓）'"
                  rules="required|max:100|regex:^[ぁ-んー]+$"
                >
                  <v-text-field
                    v-model="deliveryRequestCreateInput.delivery_name_kana1"
                    :placeholder="wordList.plc_family_name_kana"
                    density="compact"
                    variant="outlined"
                    :error-messages="errors"
                  ></v-text-field>
                </Field>
              </v-col>
              <v-col cols="6" sm="3" md="3" lg="3">
                <Field
                  v-slot="{ errors }"
                  v-model="deliveryRequestCreateInput.delivery_name_kana2"
                  name="delivery_name_kana2"
                  :label="wordList.lbl_name_kana + '（名）'"
                  rules="required|max:100|regex:^[ぁ-んー]+$"
                >
                  <v-text-field
                    v-model="deliveryRequestCreateInput.delivery_name_kana2"
                    :placeholder="wordList.plc_first_name_kana"
                    density="compact"
                    variant="outlined"
                    :error-messages="errors"
                  ></v-text-field>
                </Field>
              </v-col>
            </v-row>
            <v-row dense>
              <!-- 電話番号 -->
              <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
                <v-row align="center" dense class="form-label-row mr-3 justify-sm-end">
                  {{ wordList.lbl_tel }}
                  <ImportantChip></ImportantChip>
                </v-row>
              </v-col>
              <v-col cols="12" sm="3" md="3" lg="3">
                <Field
                  v-slot="{ errors }"
                  v-model="deliveryRequestCreateInput.delivery_phone"
                  :name="wordList.lbl_tel"
                  rules="required|numeric|min:10|max:11"
                >
                  <v-text-field
                    v-model="deliveryRequestCreateInput.delivery_phone"
                    :placeholder="wordList.plc_tel"
                    density="compact"
                    variant="outlined"
                    :error-messages="errors"
                  ></v-text-field>
                </Field>
              </v-col>
            </v-row>
            <v-row dense>
              <!-- 決済方法 -->
              <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
                <v-row align="center" dense class="form-label-row mr-3 justify-sm-end">
                  {{ wordList.lbl_pay_method }}
                  <ImportantChip></ImportantChip>
                </v-row>
              </v-col>
              <v-col cols="12" sm="4" md="4" lg="4">
                <Field
                  v-slot="{ errors }"
                  v-model="deliveryRequestCreateInput.payment_method"
                  :name="wordList.lbl_pay_method"
                  rules="required"
                >
                  <v-autocomplete
                    v-model="deliveryRequestCreateInput.payment_method"
                    density="compact"
                    :items="paymentMethodItems"
                    :placeholder="wordList.plc_selectbox"
                    :no-data-text="wordList.lbl_no_data_text"
                    :error-messages="errors"
                    :disabled="paymentMethodItems.length == 1"
                    variant="outlined"
                    return-object
                    @update:model-value="
                      onChangePaymentMethod(
                        deliveryRequestCreateInput.payment_method
                      )
                    "
                  ></v-autocomplete>
                </Field>
              </v-col>
            </v-row>
            <v-row dense>
              <!-- 支払金額 -->
              <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
                <v-row align="center"
                  v-if="paymentRequiredFlg"
                  dense
                    class="form-label-row mr-3 justify-sm-end"
                >
                  {{ wordList.lbl_pay_money }}
                  <ImportantChip></ImportantChip
                ></v-row>
                <v-row align="center"
                  v-if="!paymentRequiredFlg"
                  dense
                    class="form-label-row mr-15 justify-sm-end"
                >
                  {{ wordList.lbl_pay_money }}
                </v-row>
              </v-col>
              <v-col cols="6" sm="4" md="4" lg="4">
                <Field
                  v-if="paymentRequiredFlg"
                  v-slot="{ errors }"
                  v-model="dummy_payment_amount"
                  :name="wordList.lbl_pay_money"
                  rules="required|max:9|paymentAmount"
                >
                  <v-text-field
                    v-model="dummy_payment_amount"
                    class="payment-amount-input"
                    :placeholder="wordList.plc_pay_money"
                    density="compact"
                    variant="outlined"
                    :error-messages="errors"
                    @focus="onFocus(dummy_payment_amount)"
                    @blur="onBlur(dummy_payment_amount)"
                  >
                  </v-text-field>
                </Field>
                <Field
                  v-if="!paymentRequiredFlg"
                  v-slot="{ errors }"
                  v-model="dummy_payment_amount"
                  :name="wordList.lbl_pay_money"
                  rules="max:9|paymentAmount"
                >
                  <v-text-field
                    v-model="dummy_payment_amount"
                    class="payment-amount-input"
                    :placeholder="wordList.plc_pay_money"
                    density="compact"
                    variant="outlined"
                    :error-messages="errors"
                    @focus="onFocus(dummy_payment_amount)"
                    @blur="onBlur(dummy_payment_amount)"
                  >
                  </v-text-field>
                </Field>
              </v-col>
              <span class="mt-3">{{ wordList.lbl_yen }}</span>
            </v-row>
            <v-row v-show="setRegisterNoDisplay()" dense>
              <!-- レジNo -->
              <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
                <v-row align="center" dense class="form-label-row mr-15 justify-sm-end">{{
                  wordList.lbl_cash_register_no
                }}</v-row>
              </v-col>
              <v-col cols="2">
                <Field
                  v-slot="{ errors }"
                  v-model="deliveryRequestCreateInput.register_no"
                  :name="wordList.lbl_cash_register_no"
                  :rules="register_no_validation"
                >
                  <v-text-field
                    v-model="deliveryRequestCreateInput.register_no"
                    density="compact"
                    variant="outlined"
                    :error-messages="errors"
                  >
                  </v-text-field>
                </Field>
              </v-col>
            </v-row>
            <v-row v-show="setReceiptNoDisplay()" dense>
              <!-- レシートNo -->
              <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
                <v-row align="center" dense class="form-label-row mr-15 justify-sm-end">{{
                  wordList.lbl_receipt_no
                }}</v-row>
              </v-col>
              <v-col cols="2">
                <Field
                  v-slot="{ errors }"
                  v-model="deliveryRequestCreateInput.receipt_no"
                  :name="wordList.lbl_receipt_no"
                  :rules="receipt_no_validation"
                >
                  <v-text-field
                    v-model="deliveryRequestCreateInput.receipt_no"
                    density="compact"
                    variant="outlined"
                    :error-messages="errors"
                  >
                  </v-text-field>
                </Field>
              </v-col>
            </v-row>
            <v-row dense>
              <!-- 個口数 -->
              <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
                <v-row align="center" dense class="form-label-row mr-3 justify-sm-end"
                  >{{ wordList.lbl_unit_number }}<ImportantChip></ImportantChip
                ></v-row>
              </v-col>
              <v-col cols="6" sm="2" md="2" lg="2">
                <Field
                  v-slot="{ errors }"
                  v-model="deliveryRequestCreateInput.unit"
                  :name="wordList.lbl_unit_number"
                  rules="required|min:1"
                >
                  <v-autocomplete
                    v-model="deliveryRequestCreateInput.unit"
                    :items="unitItems"
                    :placeholder="wordList.plc_selectbox"
                    :no-data-text="wordList.lbl_no_data_text"
                    density="compact"
                    variant="outlined"
                    return-object
                    :error-messages="errors"
                  ></v-autocomplete>
                </Field>
              </v-col>
            </v-row>
            <v-row v-if="house_card_display == 1" dense>
              <!-- ハウスカード番号 -->
              <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
                <v-row align="center"
                  v-if="house_card_required == 1"
                  dense
                    class="form-label-row mr-3 justify-sm-end"
                >
                  {{ wordList.lbl_house_card }}
                  <ImportantChip></ImportantChip>
                </v-row>
                <v-row align="center" v-else dense class="form-label-row mr-3 justify-sm-end">
                  {{ wordList.lbl_house_card }}
                </v-row>
              </v-col>
              <v-col cols="6" sm="4" md="4" lg="4">
                <Field
                  v-slot="{ errors }"
                  v-model="deliveryRequestCreateInput.house_card"
                  :name="wordList.lbl_house_card"
                  :rules="house_card_validation"
                >
                  <v-text-field
                    v-if="house_card_required == 1"
                    v-model="deliveryRequestCreateInput.house_card"
                    :placeholder="wordList.plc_house_card"
                    density="compact"
                    variant="outlined"
                    :error-messages="errors"
                    :hint="wordList.lbl_house_card_hint"
                    persistent-hint
                    @change="onChangeHouseCard()"
                  ></v-text-field>
                  <v-text-field
                    v-else
                    v-model="deliveryRequestCreateInput.house_card"
                    :placeholder="wordList.plc_house_card"
                    density="compact"
                    variant="outlined"
                    :error-messages="errors"
                    persistent-hint
                    @change="onChangeHouseCard()"
                  ></v-text-field>
                </Field>
                <p></p>
              </v-col>
            </v-row>
            <v-row dense>
              <!-- 会員備考 -->
              <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
                <v-row align="center" dense class="form-label-row mr-15 justify-sm-end">{{
                  wordList.lbl_memo_member
                }}</v-row>
              </v-col>
              <v-col cols="12" sm="6" md="6" lg="6">
                <Field
                  v-slot="{ errors }"
                  v-model="deliveryRequestCreateInput.member_notes"
                  :name="wordList.lbl_memo_member"
                >
                  <v-textarea
                    v-model="deliveryRequestCreateInput.member_notes"
                    :placeholder="wordList.plc_memo_member"
                    variant="outlined"
                    :error-messages="errors"
                  >
                  </v-textarea>
                </Field>
              </v-col>
            </v-row>
            <v-row dense>
              <!-- 配達備考 -->
              <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
                <v-row align="center" dense class="form-label-row mr-15 justify-sm-end">{{
                  wordList.lbl_memo_delivery
                }}</v-row>
              </v-col>
              <v-col cols="12" sm="6" md="6" lg="6">
                <Field
                  v-slot="{ errors }"
                  v-model="deliveryRequestCreateInput.delivery_notes"
                  :name="wordList.lbl_memo_delivery"
                >
                  <v-textarea
                    v-model="deliveryRequestCreateInput.delivery_notes"
                    :placeholder="wordList.plc_memo_delivery"
                    density="compact"
                    variant="outlined"
                    :error-messages="errors"
                  >
                  </v-textarea>
                </Field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="justify-center flex-wrap">
            <v-btn
              variant="elevated"
              elevation="0"
              color="return"
              class="btn_width_1 my-2 mx-2"
              @click="onClickGoBack"
            >
              <v-icon>mdi-arrow-left</v-icon>
              {{ wordList.btn_return }}
            </v-btn>
            <v-btn
              variant="elevated"
              elevation="0"
              color="primary"
              class="btn_width_1 my-2 mx-2"
              :disabled="!meta.valid || isConfirmDisabled"
              @click="onClickOpenConfirmDialog"
            >
              <v-icon>mdi-playlist-edit</v-icon>
              {{ wordList.btn_regist_confirm }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </Form>
    </v-card>
    <!-- 配達依頼登録確認ダイアログ { -->
    <v-card v-if="isWordListReady && displayConfirmDialog" flat>
      <v-card flat>
        <v-card-title class="mb-3 text-h5 font-weight-bold">
          {{ wordList.lbl_delivery_regist_confirm }}
        </v-card-title>
        <v-card-text class="pt-5 confirm-display-text">
          <!-- ２件分配達となる場合のメッセージ -->
          <v-row v-if="isDoubleDeli" class="time_chk_card">
            <v-col cols="10" class="text-subtitle-1 text-red">
              <!-- eslint-disable-next-line vue/no-v-html -->
              <span v-html="doubleDeliCheckLabel"></span>
            </v-col>
          </v-row>
          <!-- チャーター便となる場合のメッセージ -->
          <v-row v-if="isCharterDeli" class="time_chk_card">
            <v-col cols="10" class="text-subtitle-2 text-red">
              <!-- eslint-disable-next-line vue/no-v-html -->
              <span v-html="charterDeliChkLabel"></span>
            </v-col>
          </v-row>
          <v-row dense class="mb-3">
            <!-- 配達元 -->
            <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
              <v-row align="center" dense class="form-label-row mr-15 justify-sm-end">
                {{ wordList.lbl_delivery_source }}
              </v-row>
            </v-col>
            <v-col cols="8" class="text-body-1">{{
              shopData !== null && shopData !== undefined ? shopData.name : ""
            }}</v-col>
          </v-row>
          <v-row dense class="mb-3">
            <!-- 配達先住所 -->
            <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
              <v-row align="center" dense class="form-label-row mr-3 justify-sm-end">
                {{ wordList.lbl_delivery_destination_address }}
                <ImportantChip></ImportantChip>
              </v-row>
            </v-col>
            <v-col cols="8" class="text-body-1">
              {{ deliveryRequestCreateInput.delivery_zip_code ? "〒" : "" }}
              {{ deliveryRequestCreateInput.delivery_zip_code.substring(0, 3) }}
              {{ deliveryRequestCreateInput.delivery_zip_code ? "-" : "" }}
              {{ deliveryRequestCreateInput.delivery_zip_code.substring(3) }}
              {{ deliveryRequestCreateInput.delivery_address1 }}
            </v-col>
          </v-row>
          <v-row dense class="mb-3">
            <!-- 配達先住所(番地) -->
            <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
              <v-row align="center" dense class="form-label-row mr-3 justify-sm-end">
                {{ wordList.lbl_delivery_destination_address_detail }}
                <ImportantChip></ImportantChip>
              </v-row>
            </v-col>
            <v-col cols="8" class="text-body-1">
              {{ deliveryRequestCreateInput.delivery_address2 }}
            </v-col>
          </v-row>
          <v-row dense class="mb-3">
            <!-- 建物名 部屋番号 -->
            <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
              <v-row align="center" dense class="form-label-row mr-15 justify-sm-end"
                >{{ wordList.lbl_room_num }}
              </v-row>
            </v-col>
            <v-col cols="8" class="text-body-1">
              {{ deliveryRequestCreateInput.delivery_address3 }}
            </v-col>
          </v-row>
          <v-row dense class="mb-3">
            <!-- 配達希望エリア -->
            <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black"
              ><v-row align="center" dense class="form-label-row mr-3 justify-sm-end">
                {{ wordList.lbl_delivery_area }}
                <ImportantChip></ImportantChip>
              </v-row>
            </v-col>
            <v-col cols="8" class="text-body-1">{{ deliveryAreaName }}</v-col>
          </v-row>
          <v-row dense class="mb-3">
            <!-- 配達希望時間選択 -->
            <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
              <v-row align="center" dense class="form-label-row mr-3 justify-sm-end">
                {{ wordList.lbl_delivery_time_select }}
                <ImportantChip></ImportantChip>
              </v-row>
            </v-col>
            <v-col cols="8" class="text-body-1">
              {{ displayDeliveryTime }}
            </v-col>
          </v-row>
          <!-- 配達希望時間 -->
          <v-row
            v-if="deliveryRequestCreateInput.delivery_id === 0"
            dense
              class="mb-3"
          >
            <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
              <v-row align="center" dense class="form-label-row mr-15 justify-sm-end">
                {{ wordList.lbl_delivery_time }}
              </v-row>
            </v-col>
            <v-col cols="8" class="text-body-1">
              {{ irregularDeliveryDisplayTime }}
            </v-col>
          </v-row>
          <v-row dense class="mb-3">
            <!-- お名前(漢字) -->
            <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
              <v-row align="center" dense class="form-label-row mr-3 justify-sm-end">
                {{ wordList.lbl_name_kanji }}
                <ImportantChip></ImportantChip>
              </v-row>
            </v-col>
            <v-col cols="8" class="text-body-1">
              {{ deliveryRequestCreateInput.delivery_name1 }}
              {{ deliveryRequestCreateInput.delivery_name2 }}
            </v-col>
          </v-row>
          <v-row dense class="mb-3">
            <!-- お名前(かな) -->
            <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
              <v-row align="center" dense class="form-label-row mr-3 justify-sm-end">
                {{ wordList.lbl_name_kana }}
                <ImportantChip></ImportantChip>
              </v-row>
            </v-col>
            <v-col cols="8" class="text-body-1">
              {{ deliveryRequestCreateInput.delivery_name_kana1 }}
              {{ deliveryRequestCreateInput.delivery_name_kana2 }}
            </v-col>
          </v-row>
          <v-row dense class="mb-3">
            <!-- 電話番号 -->
            <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
              <v-row align="center" dense class="form-label-row mr-3 justify-sm-end">
                {{ wordList.lbl_tel }}
                <ImportantChip></ImportantChip>
              </v-row>
            </v-col>
            <v-col cols="8" class="text-body-1">
              {{ deliveryRequestCreateInput.delivery_phone }}
            </v-col>
          </v-row>
          <v-row dense class="mb-3">
            <!-- 決済方法 -->
            <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
              <v-row align="center" dense class="form-label-row mr-3 justify-sm-end">
                {{ wordList.lbl_pay_method }}
                <ImportantChip></ImportantChip>
              </v-row>
            </v-col>
            <v-col cols="10" sm="4" md="4" lg="4" class="text-body-1">
              {{ deliveryRequestCreateInput.payment_method }}
            </v-col>
          </v-row>
          <v-row dense class="mb-3">
            <!-- 支払金額 -->
            <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
              <v-row align="center"
                v-if="paymentRequiredFlg"
                dense
                  class="form-label-row mr-3 justify-sm-end"
              >
                {{ wordList.lbl_pay_money }}
                <ImportantChip></ImportantChip>
              </v-row>
              <v-row align="center" v-else dense class="form-label-row mr-15 justify-sm-end"
                >{{ wordList.lbl_pay_money }}
              </v-row>
            </v-col>
            <v-col cols="8" sm="2" md="2" lg="2" class="text-body-1">
              {{ dummy_payment_amount }}
              <span v-if="dummy_payment_amount">{{ wordList.lbl_yen }}</span>
            </v-col>
          </v-row>
          <v-row v-show="setRegisterNoDisplay()" dense class="mb-3">
            <!-- レジNo -->
            <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black"
              ><v-row align="center" dense class="form-label-row mr-15 justify-sm-end">{{
                wordList.lbl_cash_register_no
              }}</v-row></v-col
            >
            <v-col cols="8">{{ deliveryRequestCreateInput.register_no }}</v-col>
          </v-row>
          <v-row v-show="setReceiptNoDisplay()" dense class="mb-3">
            <!-- レシートNo -->
            <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black"
              ><v-row align="center" dense class="form-label-row mr-15 justify-sm-end">{{
                wordList.lbl_receipt_no
              }}</v-row></v-col
            >
            <v-col cols="8">{{ deliveryRequestCreateInput.receipt_no }}</v-col>
          </v-row>
          <v-row dense class="mb-3">
            <!-- 個口数 -->
            <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
              <v-row align="center" dense class="form-label-row mr-3 justify-sm-end"
                >{{ wordList.lbl_unit_number }}
                <ImportantChip></ImportantChip>
              </v-row>
            </v-col>
            <v-col
              v-if="deliveryRequestCreateInput.unit > 0"
              cols="8"
              class="text-body-1"
              >{{ deliveryRequestCreateInput.unit }}個</v-col
            >
          </v-row>
          <v-row v-if="house_card_display == 1" dense class="mb-3">
            <!-- ハウスカード番号 -->
            <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
              <v-row align="center"
                v-if="house_card_required == 1"
                dense
                  class="form-label-row mr-3 justify-sm-end"
              >
                {{ wordList.lbl_house_card }}
                <ImportantChip></ImportantChip>
              </v-row>
              <v-row align="center" v-else dense class="form-label-row mr-15 justify-sm-end">
                {{ wordList.lbl_house_card }}
              </v-row>
            </v-col>
            <v-col cols="8" class="text-body-1">
              {{ deliveryRequestCreateInput.house_card }}
            </v-col>
          </v-row>
          <v-row dense class="mb-3">
            <!-- 会員備考 -->
            <v-col cols="4" sm="4" md="4" lg="4" class="font-weight-black">
              <v-row align="center" dense class="form-label-row mr-15 justify-sm-end">
                {{ wordList.lbl_memo_member }}
              </v-row>
            </v-col>
            <v-col cols="8" class="text-body-1">
              {{ deliveryRequestCreateInput.member_notes }}
            </v-col>
            <v-col offset="4" cols="8" class="text-body-1 text-caption">
              {{ messageMemberNotes }}
            </v-col>
          </v-row>
          <v-row dense class="mb-3">
            <!-- 配達備考 -->
            <v-col cols="4" sm="4" md="4" lg="4" class="font-weight-black">
              <v-row align="center" dense class="form-label-row mr-15 justify-sm-end">
                {{ wordList.lbl_memo_delivery }}
              </v-row>
            </v-col>
            <v-col cols="8" class="text-body-1">
              {{ deliveryRequestCreateInput.delivery_notes }}
            </v-col>
            <v-col offset="4" cols="8" class="text-body-1 text-caption">
              {{ messageDeliveryNotes }}
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="justify-center flex-wrap">
          <v-btn
            variant="elevated"
            elevation="0"
            color="primary"
            class="btn_width_1 my-2 mx-2"
            @click="onClickConfirmEntryAndMember"
          >
            <v-icon>mdi-playlist-edit</v-icon>
            {{ wordList.btn_delivery_member_regist }}
          </v-btn>
        </v-card-actions>
        <v-card-actions class="justify-center flex-wrap">
          <v-btn
            variant="elevated"
            elevation="0"
            color="return"
            class="btn_width_1 my-2 mx-2"
            @click="onClickConfirmCancel"
          >
            <v-icon>mdi-arrow-left</v-icon>
            {{ wordList.btn_return }}
          </v-btn>
        </v-card-actions>
        <v-overlay
          :model-value="overlay"
          class="d-flex align-center justify-center"
        >
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
      </v-card>
    </v-card>
    <!-- } 配達依頼登録確認ダイアログ -->
    <!-- 配達依頼登録完了ダイアログ { -->
    <v-card v-if="isWordListReady && displayCompletedDialog" flat>
      <v-card
        v-if="
          createDeliveryRequestMutation !== null &&
          createDeliveryRequestMutation !== undefined
        "
        flat
      >
        <v-card-title class="mb-3 text-h5 font-weight-bold">
          {{ wordList.lbl_delivery_regist_complete }}
        </v-card-title>
        <v-card-text>
          <!-- 受付可能終了時間超過メッセージ -->
          <v-row v-if="overDeliveryEndTime" class="time_chk_card">
            <v-col cols="10" class="text-subtitle-1 text-red">
              {{ wordList.lbl_delivery_time_chk }}
            </v-col>
          </v-row>
          <v-row>
            <!-- 受付番号 -->
            <v-col
              cols="12"
              sm="4"
              md="4"
              lg="4"
              class="text-h5 font-weight-black"
            >
              <v-row align="center" dense class="py-2 justify-sm-end">
                {{ wordList.lbl_reception_number }}
              </v-row>
            </v-col>
            <v-col cols="8" class="text-h5">
              {{
                createDeliveryRequestMutation.createDeliveryRequest.reception_no.substring(
                  0,
                  createDeliveryRequestMutation.createDeliveryRequest
                    .reception_no.length - 5
                ) +
                "-" +
                createDeliveryRequestMutation.createDeliveryRequest.reception_no.substring(
                  createDeliveryRequestMutation.createDeliveryRequest
                    .reception_no.length - 5
                )
              }}
            </v-col>
          </v-row>
          <v-row>
            <!-- お名前(かな) -->
            <v-col
              cols="12"
              sm="4"
              md="4"
              lg="4"
              class="text-h5 font-weight-black"
            >
              <v-row align="center" dense class="py-2 justify-sm-end">
                {{ wordList.lbl_name_kana }}
              </v-row>
            </v-col>
            <v-col cols="8" class="text-h5">
              {{
                createDeliveryRequestMutation.createDeliveryRequest
                  .delivery_name_kana1
              }}
              {{
                createDeliveryRequestMutation.createDeliveryRequest
                  .delivery_name_kana2
              }}
            </v-col>
          </v-row>
          <v-row>
            <!-- 個口数 -->
            <v-col
              cols="12"
              sm="4"
              md="4"
              lg="4"
              class="text-h5 font-weight-black"
            >
              <v-row align="center" dense class="py-2 justify-sm-end">
                {{ wordList.lbl_unit_number }}
              </v-row>
            </v-col>
            <v-col cols="8" class="text-h5">
              {{ createDeliveryRequestMutation.createDeliveryRequest.unit }}
              {{ wordList.lbl_unit }}
            </v-col>
          </v-row>
          <v-row>
            <!-- 受付時間 -->
            <v-col
              cols="12"
              sm="4"
              md="4"
              lg="4"
              class="text-h5 font-weight-black"
            >
              <v-row align="center" dense class="py-2 justify-sm-end">
                {{ wordList.lbl_reception_timedelivery }}
              </v-row>
            </v-col>
            <v-col cols="8" class="text-h5">
              {{
                createDeliveryRequestMutation.createDeliveryRequest.created_date
              }}
            </v-col>
          </v-row>
          <v-row>
            <!-- 配達希望時間 -->
            <v-col
              cols="12"
              sm="4"
              md="4"
              lg="4"
              class="text-h5 font-weight-black"
            >
              <v-row align="center" dense class="py-2 justify-sm-end">
                {{ wordList.lbl_delivery_id_time }}
              </v-row>
            </v-col>
            <v-col cols="8" class="text-h5">
              {{ deliveryIdTime }}
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions
          v-if="shopData && shopData.shippingLabelPrintFlg === 1"
          class="justify-center flex-wrap"
        >
          <v-btn
            variant="flat"
            class="btn_width_1 my-2 mx-2 px-16 mb-3"
            color="primary"
            @click="onClickTagPrintPreview"
          >
            {{ wordList.btn_tag_print_shipping_preview }}
          </v-btn>
        </v-card-actions>
        <v-card-actions
          v-if="shopData && shopData.deliveryOrderPrintFlg === 1"
          class="justify-center flex-wrap"
        >
          <v-btn
            variant="flat"
            class="btn_width_1 my-2 mx-2 px-16 mb-3"
            color="primary"
            @click="onClickSlipPrintPreview"
          >
            {{ wordList.btn_slip_print_shipping_preview }}
          </v-btn>
        </v-card-actions>
        <v-card-actions class="justify-center flex-wrap">
          <v-btn
            variant="flat"
            color="return"
            class="btn_width_1 my-2 mx-2"
            @click="onClickCompletedGoStart"
          >
            {{ wordList.btn_member_regist_return }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-card>
    <!-- } 配達依頼登録完了ダイアログ -->
    <!-- 住所選択共通ダイアログ -->
    <AddressSelectorDialog
      v-if="isWordListReady"
      :address-dialog="addressDialog"
      :area-dialog="areaDialog"
      :toggle-mode="btnNonMemberToggle"
      :zip-code="zip_code"
      :pref="prefSelectValue"
      :pref-list-items="prefListItems ?? []"
      :selected-address="selectedAddressLabel"
      :original-city="originalCityAddress"
      :city-block-list="cityBlockList ?? null"
      :section-block-list="sectionBlockList ?? null"
      :block-list="addressDialogBlockList"
      :click-disabled="clickMode"
      :area-not-select-message="addressAreaNotSelectMessage"
      :errors="addressDialogErrors"
      :word-list="wordList"
      @update:address-dialog="onAddressDialogUpdate"
      @update:area-dialog="onAreaDialogUpdate"
      @update:zip-code="onZipCodeUpdate"
      @update:pref="onPrefUpdate"
      @toggle-zip="onClickToggleZip"
      @toggle-pref="onClickTogglePref"
      @zip-input="onZipCodeInput"
      @pref-input="onPrefSelectInput"
      @search="onClickAddressChangeBtn"
      @close-address="onCloseAddressDialog"
      @area-return="onClickAreaDialogReturn"
      @select-city="onClickCityBlockLink"
      @select-section="onClickSectionBlockLink"
      @select-block="onClickAddressBlockLink"
    />
    <!-- 荷札印刷ダイアログ {-->
    <TagLabelPrintDialog
      ref="tagLabelPrintDialogRef"
      v-model:confirm-tag-print-dialog="confirmTagPrintDialog"
      :print-shipping-data="tagPrintShippingData"
      :overlay="overlay"
    />

    <!-- } 荷札印刷ダイアログ -->
    <!-- 伝票印刷ダイアログ {-->
    <SlipLabelPrintDialog
      ref="slipLabelPrintDialogRef"
      v-model:confirm-slip-print-dialog="confirmSlipPrintDialog"
      :print-shipping-data="slipPrintShippingData"
      :overlay="overlay"
    />
    <!-- } 伝票印刷ダイアログ -->
    <AlertDialog
      v-model="errdialog"
      :title="wordList.lbl_err_dialog_title"
      :message="errMessage"
      type="error"
      :ok-text="backToStart ? '戻る' : 'OK'"
      @ok="backToStart ? onClickBackToStart() : null"
    />
  </v-container>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';
import { Form, Field, defineRule, configure } from 'vee-validate';
import type { FormContext } from 'vee-validate';
import { localize } from '@vee-validate/i18n';
import { required, max, min, numeric, regex, length } from '@vee-validate/rules';
import ja from '@vee-validate/i18n/dist/locale/ja.json';
import ImportantChip from '@/components/ImportantChip.vue';
import AlertDialog from "@/components/AlertDialog.vue";
import SlipLabelPrintDialog from '@/components/SlipLabelPrintDialog.vue';
import TagLabelPrintDialog from '@/components/TagLabelPrintDialog.vue';
import AddressSelectorDialog from '@/components/address-selector/AddressSelectorDialog.vue';
import type {
  AddressBlockItem as SharedAddressBlockItem,
  AddressSelectionErrors,
} from '@/components/address-selector/types';
import { useDeliveryRequestRegisterState } from './composables/useDeliveryRequestRegisterState';
import { useDeliveryRequestRegisterDeliveryTime } from './composables/useDeliveryRequestRegisterDeliveryTime';
import { useDeliveryRequestRegisterAddress } from './composables/useDeliveryRequestRegisterAddress';
import { useDeliveryRequestRegisterPayment } from './composables/useDeliveryRequestRegisterPayment';
import { useDeliveryRequestRegisterConfirm } from './composables/useDeliveryRequestRegisterConfirm';
import { useDeliveryRequestRegisterSubmit } from './composables/useDeliveryRequestRegisterSubmit';
import { useDeliveryRequestRegisterPrint } from './composables/useDeliveryRequestRegisterPrint';
import { useDeliveryRequestRegisterUi } from './composables/useDeliveryRequestRegisterUi';
import { useDeliveryRequestRegisterInit } from './composables/useDeliveryRequestRegisterInit';
import { useRouter } from 'vue-router';
import { routerPath } from '@/common/router';
import type { CreateDeliveryRequestMutation } from '@/generated/graphql';

defineRule('required', required);
defineRule('max', max);
defineRule('min', min);
defineRule('numeric', numeric);
defineRule('regex', regex);
defineRule('length', length);
defineRule('paymentAmount', (value: unknown) => {
  if (value === null || value === undefined || String(value).trim() === '') {
    return true;
  }
  return /^[0-9,]+$/.test(String(value)) || '数値およびカンマのみ入力してください';
});
configure({
  generateMessage: localize({
    ja,
  }),
});
localize("ja");

const state = useDeliveryRequestRegisterState();
const {
  wordList,
  isWordListReady,
  dummy_payment_amount,
  pref_name,
  zip_code,
  user_id,
  deliveryAvailabilityStore,
  pref_name_befor,
  shopData,
  tmpMemberData,
  unitItems,
  paymentMethodItems,
  paymentRequiredFlg,
  btnNonMemberToggle,
  userErrorMessage,
  errorPrefSelect,
  zipAddressList,
  zipCodeFromPref,
  cityBlockList,
  originalAddress,
  originalSectionAddress,
  originalCityAddress,
  originalBlockName,
  sectionBlockList,
  blockList,
  unassignedBlockList,
  addressBlockList,
  prefListItems,
  memberData,
  listDeliveryArea,
  deliveryAreaName,
  prefSelectValue,
  acceptableEndTime,
  tagPrintShippingData,
  slipPrintShippingData,
  deliveryStartHourItem,
  deliveryStartHourValues,
  deliveryStartMinitItem,
  deliveryStartMinitValues,
  irregularDeliveryStartTime,
  irregularDeliveryEndTime,
  irregularDeliveryDisplayTime,
  deliveryId_0_Flg,
  deliveryStartTime,
  deliveryEndTime,
  overDeliveryEndTime,
  doubleDeliOriconCount,
  isDoubleDeli,
  charterDeliOriconCount,
  isCharterDeli,
  deliveryAvailabilityHeader,
  deliveryAvailabilityData,
  disp_deliveryAvailabilityData,
  displayDeliveryTime,
  deliverySelectDayBox,
  deliverySelectBox,
  is_hide_delivery_time_on_spot,
  overlay,
  errdialog,
  errMessage,
  areaDialog,
  getAvailableDate,
  backToStart,
  addressFixed,
  addressDialog,
  commaPyamentAmount,
  errorZipCode,
  house_card_display,
  house_card_validation,
  house_card_required,
  house_card_change,
  house_card_before,
  register_no_max_length,
  register_no_validation,
  receipt_no_max_length,
  receipt_no_validation,
  memberNotesBefore,
  deliveryNotesBefore,
  messageMemberNotes,
  messageDeliveryNotes,
  clickMode,
  deliveryRequestCreateInput,
  memberCreateInput,
  memberUpdateInput,
  tmpMemberUpdateInput,
  operationInput,
} = state;

const formRef = ref<FormContext | null>(null);
const tagLabelPrintDialogRef = ref<InstanceType<typeof TagLabelPrintDialog> | null>(null);
const slipLabelPrintDialogRef = ref<InstanceType<typeof SlipLabelPrintDialog> | null>(null);
const confirmTagPrintDialog = ref(false);
const confirmSlipPrintDialog = ref(false);
const createDeliveryRequestMutation = ref<CreateDeliveryRequestMutation | null>(null);
const displayConfirmDialog = ref(false);
const displayCompletedDialog = ref(false);
const deliveryIdTime = ref("");

const { onChangePaymentMethod, commmaMoney, onFocus, onBlur } =
  useDeliveryRequestRegisterPayment({
    paymentRequiredFlg,
    dummy_payment_amount,
    errdialog,
    errMessage,
  });

const {
  getDeliveryTimeList,
  onDeliveryAvailabilityClick,
  onChangeDeliveryStartHour,
  onChangeDeliveryStartMinit,
} = useDeliveryRequestRegisterDeliveryTime({
  listDeliveryArea,
  deliveryAvailabilityStore,
  deliveryAvailabilityHeader,
  deliveryAvailabilityData,
  disp_deliveryAvailabilityData,
  deliveryRequestCreateInput,
  deliveryAreaName,
  deliveryId_0_Flg,
  deliveryStartHourItem,
  deliveryStartHourValues,
  deliveryStartMinitItem,
  deliveryStartMinitValues,
  displayDeliveryTime,
  deliverySelectDayBox,
  deliverySelectBox,
  deliveryStartTime,
  deliveryEndTime,
  acceptableEndTime,
  errdialog,
  errMessage,
  sectionBlockList,
  blockList,
  originalCityAddress,
  originalSectionAddress,
  originalAddress,
  originalBlockName,
  zipCodeFromPref,
  irregularDeliveryStartTime,
  irregularDeliveryEndTime,
  irregularDeliveryDisplayTime,
});

const {
  initializeAddress,
  onClickAddressUpdate,
  onClickAddressChangeBtn,
  onClickCityBlockLink,
  onClickSectionBlockLink,
  onClickAddressBlockLink,
  onClickListDeliveryArea,
  onClickAreaDialogReturn,
  onClickToggleZip,
  onClickTogglePref,
  onPrefSelectInput,
  onZipCodeInput,
  areaClear,
  areaAddresSelectClear,
  getAreaList,
  getAreaInfo,
  setDeliveryAreaSectionUnassigned,
} = useDeliveryRequestRegisterAddress({
  wordList,
  errdialog,
  errMessage,
  pref_name,
  pref_name_befor,
  zip_code,
  btnNonMemberToggle,
  errorZipCode,
  errorPrefSelect,
  userErrorMessage,
  prefListItems,
  prefSelectValue,
  addressDialog,
  addressFixed,
  areaDialog,
  cityBlockList,
  sectionBlockList,
  blockList,
  unassignedBlockList,
  addressBlockList,
  zipAddressList,
  zipCodeFromPref,
  originalAddress,
  originalSectionAddress,
  originalCityAddress,
  originalBlockName,
  clickMode,
  listDeliveryArea,
  deliveryAreaName,
  acceptableEndTime,
  deliveryAvailabilityHeader,
  deliveryAvailabilityData,
  disp_deliveryAvailabilityData,
  deliveryId_0_Flg,
  deliveryStartHourItem,
  deliveryStartHourValues,
  deliveryStartMinitValues,
  displayDeliveryTime,
  deliverySelectDayBox,
  deliverySelectBox,
  deliveryStartTime,
  deliveryRequestCreateInput,
  getDeliveryTimeList,
});

const {
  onClickOpenConfirmDialog,
  isConfirmDisabled,
  doubleDeliCheckLabel,
  charterDeliChkLabel,
} = useDeliveryRequestRegisterConfirm({
  formRef,
  displayConfirmDialog,
  deliveryRequestCreateInput,
  commaPyamentAmount,
  dummy_payment_amount,
  memberNotesBefore,
  deliveryNotesBefore,
  messageMemberNotes,
  messageDeliveryNotes,
  isDoubleDeli,
  isCharterDeli,
  doubleDeliOriconCount,
  charterDeliOriconCount,
  paymentRequiredFlg,
  house_card_required,
  wordList,
  displayDeliveryTime,
  isWordListReady,
});

const {
  onClickConfirmCancel,
  onClickConfirmEntryAndMember,
  onClickCompletedGoStart,
  onClickGoBack,
} = useDeliveryRequestRegisterSubmit({
  overlay,
  errdialog,
  errMessage,
  displayConfirmDialog,
  displayCompletedDialog,
  overDeliveryEndTime,
  deliveryId_0_Flg,
  isDoubleDeli,
  isCharterDeli,
  deliveryStartHourValues,
  deliveryStartMinitValues,
  irregularDeliveryStartTime,
  irregularDeliveryEndTime,
  acceptableEndTime,
  deliveryIdTime,
  deliveryRequestCreateInput,
  memberCreateInput,
  memberUpdateInput,
  tmpMemberUpdateInput,
  operationInput,
  dummy_payment_amount,
  memberNotesBefore,
  deliveryNotesBefore,
  messageMemberNotes,
  messageDeliveryNotes,
  createDeliveryRequestMutation,
});

const {
  onClickTagPrintPreview,
  onClickSlipPrintPreview,
} = useDeliveryRequestRegisterPrint({
  createDeliveryRequestMutation,
  deliveryRequestCreateInput,
  shopData,
  tagPrintShippingData,
  slipPrintShippingData,
  confirmTagPrintDialog,
  confirmSlipPrintDialog,
  tagLabelPrintDialogRef,
  slipLabelPrintDialogRef,
  wordList,
});

const { setRegisterNoDisplay, setReceiptNoDisplay, formatDate, areaNotSelectLabel } =
  useDeliveryRequestRegisterUi({
    register_no_max_length,
    receipt_no_max_length,
    unassignedBlockList,
    wordList,
  });

useDeliveryRequestRegisterInit({
  wordList,
  errdialog,
  errMessage,
  backToStart,
  getAvailableDate,
  deliveryRequestCreateInput,
  operationInput,
  house_card_display,
  house_card_validation,
  house_card_required,
  register_no_max_length,
  receipt_no_max_length,
  register_no_validation,
  receipt_no_validation,
  shopData,
  paymentMethodItems,
  unitItems,
  is_hide_delivery_time_on_spot,
  memberData,
  tmpMemberData,
  house_card_before,
  house_card_change,
  originalAddress,
  initializeAddress,
  getAreaList,
  commmaMoney,
  onChangePaymentMethod,
});

const router = useRouter();
const onClickBackToStart = async (): Promise<void> => {
  await router.push({
    path: routerPath.deliveryRequestRegisterStart,
  });
};

const onChangeHouseCard = async (): Promise<void> => {
  if (deliveryRequestCreateInput.house_card !== house_card_before.value) {
    house_card_change.value = true;
    if (deliveryRequestCreateInput.house_card == "") {
      overlay.value = false;
      errdialog.value = true;
      errMessage.value =
        "ハウスカード番号をクリアする場合、会員情報のハウスカード番号もクリアされます。";
      return;
    }
  } else {
    house_card_change.value = false;
  }
};

/** 住所選択ダイアログで表示する選択中住所。 */
const selectedAddressLabel = computed(() => {
  if (user_id.value.length <= 0 || pref_name.value.length > 0) {
    return `${pref_name.value}${originalCityAddress.value}${originalSectionAddress.value}`;
  }
  return originalAddress.value;
});

/** 共通ダイアログ向けに丁目候補を正規化する。 */
const addressDialogBlockList = computed<SharedAddressBlockItem[]>(() => {
  return (blockList.value ?? []).filter(
    (value): value is SharedAddressBlockItem => value !== null && value !== undefined
  );
});

/** 共通ダイアログ向けにエラーを集約する。 */
const addressDialogErrors = computed<AddressSelectionErrors>(() => {
  return {
    zip: errorZipCode.value,
    pref: errorPrefSelect.value,
    general: userErrorMessage.value,
  };
});

/** 配達対象外メッセージは対象丁目がある時のみ表示する。 */
const addressAreaNotSelectMessage = computed(() => {
  if (!unassignedBlockList.value || unassignedBlockList.value.length === 0) {
    return "";
  }
  return areaNotSelectLabel.value;
});

/** addressDialog の v-model 更新を反映する。 */
const onAddressDialogUpdate = (value: boolean): void => {
  addressDialog.value = value;
};

/** areaDialog の v-model 更新を反映する。 */
const onAreaDialogUpdate = (value: boolean): void => {
  areaDialog.value = value;
};

/** 郵便番号入力値の更新を反映する。 */
const onZipCodeUpdate = (value: string): void => {
  zip_code.value = value;
};

/** 都道府県入力値の更新を反映する。 */
const onPrefUpdate = (value: string): void => {
  prefSelectValue.value = value;
};

/** 住所ダイアログの戻る操作を処理する。 */
const onCloseAddressDialog = (): void => {
  addressDialog.value = false;
  pref_name.value = pref_name_befor.value;
};
</script>

<style scoped>
/* 支払金額入力欄: 入力値は右寄せ、バリデーションエラーメッセージは左寄せ */
.payment-amount-input :deep(input) {
  text-align: right;
}
</style>
